export default function LandingPage({ onLogin }) {
  return (
    <div style={s.wrap}>
      {/* Header */}
      <div style={s.nav}>
        <div style={s.navLogo}>
          <div style={s.logoMark}>₹</div>
          <span style={s.logoText}>PaisaTrack</span>
        </div>
        <button style={s.navBtn} onClick={onLogin}>Sign in</button>
      </div>

      {/* Hero */}
      <div style={s.hero}>
        <div style={s.badge}>Free · No ads · Made in India</div>
        <h1 style={s.h1}>Know where every<br/>rupee went.</h1>
        <p style={s.sub}>Track UPI, cash, and card spends in seconds. Set budgets, get nudges before you overspend, and see your monthly picture clearly.</p>
        <button style={s.cta} onClick={onLogin}>Get started free →</button>
        <p style={s.hint}>No app store needed · Works on Android & iPhone</p>
      </div>

      {/* Features */}
      <div style={s.features}>
        {[
          { icon: '📱', title: 'All payment modes', desc: 'UPI, GPay, PhonePe, cash, credit card, debit card — all in one place.' },
          { icon: '🔔', title: 'Budget nudges', desc: 'Set monthly limits per category. Get alerted at 80% before you overspend.' },
          { icon: '👨‍👩‍👧', title: 'Family mode', desc: 'Couples and families track together with shared household view.' },
          { icon: '🇮🇳', title: 'Data stays in India', desc: 'Your data is stored in Mumbai. Never sold. Never shared. Yours alone.' },
          { icon: '📊', title: 'Monthly summary', desc: 'Charts by category and payment mode. See where your money actually went.' },
          { icon: '🔒', title: 'Privacy first', desc: 'No bank linking. No SMS access. No ads. Just simple, honest tracking.' },
        ].map(f => (
          <div key={f.title} style={s.featureCard}>
            <div style={s.featureIcon}>{f.icon}</div>
            <div style={s.featureTitle}>{f.title}</div>
            <div style={s.featureDesc}>{f.desc}</div>
          </div>
        ))}
      </div>

      {/* CTA bottom */}
      <div style={s.bottom}>
        <h2 style={s.bottomH}>Start tracking today — it's free.</h2>
        <button style={s.cta} onClick={onLogin}>Create your account →</button>
        <p style={s.bottomSub}>Already have an account? <button style={s.link} onClick={onLogin}>Sign in</button></p>
      </div>

      {/* Footer */}
      <div style={s.footer}>
        <span>© 2026 PaisaTrack</span>
        <a href="/privacy" style={s.footerLink}>Privacy Policy</a>
        <span>vjkumarbb@gmail.com</span>
      </div>
    </div>
  )
}

const s = {
  wrap:        { minHeight: '100vh', background: '#F7F4EF', fontFamily: "'DM Sans', sans-serif" },
  nav:         { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1.5rem', background: '#1A1A2E' },
  navLogo:     { display: 'flex', alignItems: 'center', gap: 10 },
  logoMark:    { width: 36, height: 36, background: '#E8C547', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, fontWeight: 700, color: '#1A1A2E' },
  logoText:    { fontSize: 18, fontWeight: 700, color: '#fff' },
  navBtn:      { padding: '8px 20px', background: '#E8C547', color: '#1A1A2E', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  hero:        { textAlign: 'center', padding: '4rem 1.5rem 3rem', maxWidth: 600, margin: '0 auto' },
  badge:       { display: 'inline-block', background: '#E8C547', color: '#1A1A2E', fontSize: 12, fontWeight: 700, padding: '4px 14px', borderRadius: 20, marginBottom: 20, letterSpacing: 0.5 },
  h1:          { fontSize: 'clamp(2rem, 6vw, 3rem)', fontWeight: 700, color: '#1A1A2E', lineHeight: 1.15, margin: '0 0 1rem', letterSpacing: '-0.5px' },
  sub:         { fontSize: 18, color: '#555', lineHeight: 1.6, marginBottom: 2 },
  cta:         { display: 'inline-block', marginTop: 24, padding: '14px 32px', background: '#1A1A2E', color: '#E8C547', border: 'none', borderRadius: 12, fontSize: 16, fontWeight: 700, cursor: 'pointer', letterSpacing: 0.3 },
  hint:        { fontSize: 13, color: '#aaa', marginTop: 12 },
  features:    { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 16, padding: '0 1.5rem 3rem', maxWidth: 900, margin: '0 auto' },
  featureCard: { background: '#fff', borderRadius: 16, padding: '1.5rem', border: '1px solid #E8E4DC' },
  featureIcon: { fontSize: 28, marginBottom: 10 },
  featureTitle:{ fontSize: 15, fontWeight: 700, color: '#1A1A2E', marginBottom: 6 },
  featureDesc: { fontSize: 14, color: '#666', lineHeight: 1.5 },
  bottom:      { textAlign: 'center', padding: '3rem 1.5rem', background: '#1A1A2E' },
  bottomH:     { fontSize: 24, fontWeight: 700, color: '#fff', marginBottom: 8 },
  bottomSub:   { fontSize: 14, color: '#888', marginTop: 16 },
  link:        { background: 'none', border: 'none', color: '#E8C547', cursor: 'pointer', fontSize: 14 },
  footer:      { display: 'flex', justifyContent: 'center', gap: 24, padding: '1.5rem', fontSize: 13, color: '#888', background: '#1A1A2E', borderTop: '1px solid #2A2A3E', flexWrap: 'wrap' },
  footerLink:  { color: '#888', textDecoration: 'none' },
}
